export function sanitizeString(str: string): string {
  // Remove leading and trailing spaces
  const trimmedStr = str.trim();

  // Replace consecutive spaces with a single space
  return trimmedStr.replace(/\s+/g, ' ');
}
